/**
 * Feature flags of the chat container, one per backend capability.
 * The initial coarse CHAT_PHASE2_ENABLED was split as phase-2 backend
 * features land one by one — flip a flag when its backend part ships.
 */

/** Message reactions (POST /messages/{uuid}/reactions + message:reaction) */
export const CHAT_REACTIONS_ENABLED = true

/** File/photo/video attachments (upload + attach flow) */
export const CHAT_ATTACHMENTS_ENABLED = true

/** Delivery receipts: sent ✓ / read ✓✓ (message:delivery events) */
export const CHAT_DELIVERY_ENABLED = true

/** Typing indicator (POST /typing + typing:start events, TTL on the client) */
export const CHAT_TYPING_ENABLED = true

/** User presence: online indicator + lastSeen (quasi: from last_activity_at) */
export const CHAT_PRESENCE_ENABLED = true
